
import type { SaleType } from 'app/dataTypes/dishes/saleType'
import type { Request } from '../../../index'


type ApiResult = Array<{ id: number, title: string, reserved: boolean }>

export const convertResult = (data: ApiResult): Array<SaleType> => {
  return data.map(({ id, title, reserved }): SaleType => ({ id: String(id), title, reserved }))
}

export const GET_SALE_TYPES: Request<
  null,
  Array<SaleType>,
  null
> = [
  'food/items/sale_types',
  'get',
  ['data', 'sale_types'],
]
